export default [
    {
        path: '',
        name: 'pageGovernanceRouter',
        component: () => import('./page-governance')
    }
]